let isNormal = {
  0: "true",
  1: "true",
  2: "true",
};
export { isNormal };
